(ns frontend.actions.common
  (:require
   [frontend.conn :as conn]
   [frontend.logging :as logging]
   [promesa.core :as p]))

;; NOTE
;; Should be one-to-one mapping with domain/company
;; No other tasks should be performed here
;; Should only be required in `events` files
;; Function signatures should always be
;; [data on-success! on-error!]
;; Keep it Simple and Silly

(defn *<-create-op-token
  [data on-success! on-error!]
  (-> (conn/sendp! :token/create-op-token nil)
      (p/then (fn [resp]
                (on-success! (-> resp
                                 :body
                                 :token))))
      (p/catch on-error!)))

(defn *->delete-op-token
  [data on-success! on-error!]
  (-> (conn/sendp! :token/remove-token data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *<-app-config
  [data on-success! on-error!]
  (-> (conn/sendp! :app/config data 10000 true)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->crop-image
  [data on-success! on-error!]
  (-> (conn/sendp! :common/crop-image data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->archive!
  [data on-success! on-error!]
  (-> (conn/sendp! :common/archive data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->unarchive!
  [data on-success! on-error!]
  (-> (conn/sendp! :common/unarchive data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->delete-flag
  [data on-success! on-error!] ;;TODO do we need to add analytics for flagging?
  (-> (conn/sendp! :account/remove-entity-from-flagged
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->add-flag
  [data on-success! on-error!] ;;TODO do we need to add analytics for flagging?
  (-> (conn/sendp! :account/add-entity-as-flagged
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn toggle-flag
  [entity flagged?]
  (let [data {:entity-id   (:db/id entity)
              :entity-type (:entity/type entity)}
        on-success! (partial logging/unimplemented "toggle-flag!")
        on-error! (partial logging/error "toggle-flag!")]
    (if flagged?
      (*->delete-flag data on-success! on-error!)
      (*->add-flag data on-success! on-error!))))
